import styled from "styled-components";

const Crudls = () => {
  return <div>Crudls</div>;
};

export default Crudls;
